<template>
    <div>
        <Invitacion v-if="Template == 34" :code="codigo" />
    </div>
</template>

<script>
import Invitacion from '@/components/Templates/Template1.vue';

import axios from 'axios';
import moment from 'moment';

export default {
    props: ['invitado', 'cantidad', 'id'],
    components: {
        Invitacion
    },
    data() {
        return {
            preload: true,
            Template: 0,
            codigo: "NavidadSkycom-38"
        }
    },
    methods: {
        goToInvitation() {
            setTimeout(function () {
                this.preload = false
            }.bind(this), 6500);
        },

        GetTemplateEvent() {
            let url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}Template/GetTemplateEvent/${this.codigo}` : `${process.env.VUE_APP_API_PRO}Template/GetTemplateEvent/${this.codigo}`;
            axios.get(url)
                .then((response) => this.Template = response.data.IdPlantilla)
                .catch(err => console.error(err));
        },
        saveLog() {
            const browserName = navigator.userAgent;
            const parsedBrowser = (browserName.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [])[1];
            const parsedVersion = parsedBrowser == 'Chrome' ? (browserName.match(/Chrome\/(\d+)/)[1]) : (browserName.match(/version\/(\d+)/i) || [])[1];
            const osName = navigator.platform;

            const url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}logsAccess` : `${process.env.VUE_APP_API_PRO}logsAccess`;
            const data = {
                Browser: parsedBrowser,
                Version: parsedVersion,
                OsName: osName,
                ts: moment(new Date()).locale("es-mx").format("YYYY-MM-DD H:mm"),
                Code: this.codigo
            }
            axios.post(url, data)
            .then(() => {
            }).catch((err) => console.error(err));
        }
    },
    created() {
        this.GetTemplateEvent();
        this.goToInvitation();
        this.saveLog()
    },
    mounted() {
    },
}
</script>

<style scoped></style>